import { useQuery } from '@apollo/client';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ApolloProviderV4 } from '~/apollo/client-v4';
import { graphql } from '~/apollo/generated/v4';
import { NotFound } from '~/components/common/NotFound';
import { Panel } from '~/components/common/Panel';
import { SpinnerPlaceholder } from '~/components/common/SpinnerPlaceholder';
import { Button } from '~/components/ui/button';
import { CreateLithostratOutcropLinkModalV4 } from '~/components/upload/lithostrat/lithostrat-link/create-lithostrat-outcrop-link';
import { OutcropLithostratLinksTable } from '~/components/upload/lithostrat/lithostrat-link/lithostrat-outcrop-links-table';
import { useRouteParam } from '~/hooks/routing';
import { createRefetchQueries } from '~/utils/graphql';

const UPLOAD_OUTCROP_LITHOSTRATIGRAPHY_PAGE = graphql(`
  query UploadOutcropLithostratigraphyPage($id: ID!) {
    outcropGet(id: $id) {
      id
      lithostratOutcropLinks {
        ...lithostratOutcropLinkParts
      }
    }
  }
`);

export default function UpdateOutcropLithostratigraphyPage() {
  return (
    <ApolloProviderV4>
      <UpdateOutcropLithostratigraphyPageInner />
    </ApolloProviderV4>
  );
}

function UpdateOutcropLithostratigraphyPageInner() {
  const outcropId = useRouteParam('outcropId', parseInt);

  const { data, loading } = useQuery(UPLOAD_OUTCROP_LITHOSTRATIGRAPHY_PAGE, {
    variables: { id: outcropId },
  });

  const refetchQueries = createRefetchQueries([
    {
      query: UPLOAD_OUTCROP_LITHOSTRATIGRAPHY_PAGE,
      variables: { id: outcropId },
    },
  ]);

  const outcrop = data?.outcropGet;
  const links = outcrop?.lithostratOutcropLinks ?? [];

  if (loading) return <SpinnerPlaceholder />;
  if (!outcrop) return <NotFound />;

  return (
    <Panel>
      <Panel.Heading className="flex justify-between">
        <Panel.Title>Lithostrat Links</Panel.Title>

        <CreateLithostratOutcropLinkModalV4
          outcropId={outcropId}
          refetchQueries={refetchQueries}
        >
          {showModal => (
            <Button
              type="button"
              color="primary"
              size="xs"
              onClick={showModal}
              className="gap-1"
            >
              <FontAwesomeIcon icon={faPlus} /> Create Link
            </Button>
          )}
        </CreateLithostratOutcropLinkModalV4>
      </Panel.Heading>

      <Panel.Body>
        <OutcropLithostratLinksTable
          links={links}
          refetchQueries={refetchQueries}
        />
      </Panel.Body>
    </Panel>
  );
}
